export default [
	//靓号相关
	{
		path: '/admindingdan',
		name: 'admindingdan',
		component: () => import('@/components/admin/admindingdan')
	},
  {
  	path: '/adminyijianfankui',
  	name: 'adminyijianfankui',
  	component: () => import('@/components/admin2/adminyijianfankui')
  },

  {
  	path: '/admindianpu',
  	name: 'admindianpu',
  	component: () => import('@/components/admin/admindianpu')
  },
  {
  	path: '/adminfpgl',
  	name: 'adminfpgl',
  	component: () => import('@/components/admin/adminfpgl')
  },
  {
  	path: '/adminfpgl/adminfpgl2',
  	name: 'adminfpgl2',
  	component: () => import('@/components/admin/adminfpgl2')
  },

	{
		path: '/adminshangjia',
		name: 'adminshangjia',
		component: () => import('@/components/admin/adminshangjia')
	},
	{
		path: '/admincaozuo',
		name: 'admincaozuo',
		component: () => import('@/components/admin/admincaozuo')
	},
  {
  	path: '/adminmoban',
  	name: 'adminmoban',
  	component: () => import('@/components/admin/adminmoban')
  },
  {
  	path: '/adminduanxin',
  	name: 'adminduanxin',
  	component: () => import('@/components/admin/adminduanxin')
  },
	{
		path: '/adminheimingdan',
		name: 'adminheimingdan',
		component: () => import('@/components/admin/adminheimingdan')
	},
   {
		path: '/adminqianming',
		name: 'adminqianming',
		component: () => import('@/components/admin/adminqianming')
	},
	{
		path: '/admincaiwushenhe',
		name: 'admincaiwushenhe',
		component: () => import('@/components/admin/admincaiwushenhe')
	},
	{
		path: '/adminxianxiachongzhi',
		name: 'adminqianming2',
		component: () => import('@/components/admin/adminxianxiachongzhi')
	},
  {
  	path: '/admindianpuchaxun',
  	name: 'admindianpuchaxun',
  	component: () => import('@/components/admin/admindianpuchaxun')
  },
	{
		path: '/dingdan',
		name: 'dingdan',
		component: () => import('@/components/admin/dingdan')
	},

	{
		path: '/shangpin',
		name: 'shangpin',
		component: () => import('@/components/admin/shangpin')
	},
	{
		path: '/zhuadan',
		name: 'zhuadan',
		component: () => import('@/components/admin/zhuadan')
	},
	{
		path: '/yonghu',
		name: 'yonghu',
		component: () => import('@/components/admin/yonghu')
	},
	{
		path: '/chanpin',
		name: 'chanpin',
		component: () => import('@/components/admin/chanpin')
	},
	{
		path: '/mySupplier',
		name: 'mySupplier',
		component: () => import('@/components/mySupplier/mySupplier')
	},
	{
		path: '/adminzfdd',
		name: 'adminzfdd',
		component: () => import('@/components/admin/adminzfdd')
	},
	{
		path: '/adminydjqd',
		name: 'adminydjqd',
		component: () => import('@/components/admin/adminydjqd'),
	},
  {
  	path: '/adminydjqd/adminkuaidi',
  	name: 'adminkuaidi',
  	component: () => import('@/components/admin/adminkuaidi'),
  },
	{
		path: '/admindpgl',
		name: 'admindpgl',
		component: () => import('@/components/admin/admindpgl')
	},
	{
		path: '/admindptk',
		name: 'admindptk',
		component: () => import('@/components/admin/admindptk')
	},
  {
  	path: '/admintaowa',
  	name: 'admintaowa',
  	component: () => import('@/components/admin/admintaowa')
  },
  {
	path: '/adminjkqdgl',
	name: 'adminjkqdgl',
	component: () => import('@/components/admin/adminjkqdgl')
  },
  {
  path: '/adminduilie',
  name: 'adminduilie',
  component: () => import('@/components/admin/adminduilie')
  },
  


  {
  	path: '/adminzd',
  	name: 'adminzd',
  	component: () => import('@/components/admin/zhuadan/index'),
    redirect: '/adminzd/admintm',
  	children: [{
  			path: '/adminzd/admintm',
  			name:'admintm',
  			component: () => import('@/components/admin/zhuadan/admintm')
  		},
      {
      		path: '/adminzd/adminjd',
      		name:'adminjd',
      		component: () => import('@/components/admin/zhuadan/adminjd')
      	}
  	]
  },

]



// WEBPACK FOOTER //
// ./src/router/admin.js